import React, { memo } from "react";
import cls from "classnames";
import { List } from "@al/akui-mobile";

import Iconfont from "~/components/ui/Iconfont";

import styles from "./styles.scss";

type Props = {
  title: string;
  className?: string;
  itemClassName?: string;
  subTitle: React.ReactNode;
  subTitleClassName?: string;
  bottomContent?: React.ReactNode;
  onClick?: () => void;
  onClickTitle?: () => void;
};

const FunctionItem: React.FC<Props> = (props) => {
  const { title, subTitle, bottomContent, subTitleClassName } = props;
  return (
    <List.Item
      key={props.title}
      className={cls(styles.list_item, props.className)}
      arrow={null}
      onClick={props.onClick}
    >
      <div className={cls(styles.item, props.itemClassName)} onClick={props?.onClickTitle}>
        <div className={styles.item_info}>
          <div className={styles.title}>{title}</div>
          <div className={cls(styles.sub_title, subTitleClassName)}>{subTitle}</div>
        </div>
        <Iconfont className={styles.right_icon} name="right" />
      </div>
      {bottomContent}
    </List.Item>
  );
};

export default memo(FunctionItem);
